<template>
  <div class="Grouplist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right: -10px;color:rgba(52,152,219,1);"
        ></i>
        团购商品列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting()">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      </div>
      <div style="background-color:#fff;">
        <el-row class="search" :gutter="10">
          <el-col :span="2">
            <div class="label">商品名称:</div>
          </el-col>
          <el-col :span="5">
            <el-input clearable v-model="product" size="small" placeholder="商品名称"></el-input>
          </el-col>
          <el-col :span="14" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="filtrate_center">
        <div class="center_list_head">
          <div class="center_list_head_left">
            <div>
              <i class="fas fa-bars"></i>
            </div>
            <div>数据列表</div>
          </div>
          <router-link to="./c_addgroup" class="center_list_head_rig">添加商品</router-link>
        </div>
        <div class="center_list_center"></div>
      </div>
      <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
        <el-table-column prop="title" width="160" show-overflow-tooltip label="商品名称" align="center"></el-table-column>
        <el-table-column prop="selling_price" label="原价" align="center"></el-table-column>
        <el-table-column prop="g_price" label="团购价" align="center"></el-table-column>
        <el-table-column prop="p_number" label="总数量" align="center"></el-table-column>
        <el-table-column prop="yet" label="已团购" align="center"></el-table-column>
        <el-table-column prop="surplus" label="剩余数量" align="center"></el-table-column>
        <el-table-column prop="g_number" label="开团人数" align="center"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="110"
          prop="start_date"
          label="开始时间"
          align="center"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="110"
          prop="end_date"
          label="结束时间"
          align="center"
        ></el-table-column>

        <el-table-column label="操作" width="150" align="center" name="bianji">
          <template slot-scope="scope" style="display:flex;padding:0;margin:0">
            <button @click="dialogFormVisible1 = true,red(scope.row.group_id)" class="button1">编辑</button>
            <button @click="del(scope.row.group_id)" class="button1">删除</button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-row>
          <el-col :span="8"></el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              @current-change="setPage"
            >1</el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 编辑商品 -->
    <el-dialog title="编辑" :visible.sync="dialogFormVisible1" width="33%">
      <el-form>
        <el-form-item label="　团购价:">
          <el-input style="width:356px" v-model="group_price" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开团人数:">
          <el-input style="width:356px" v-model="group_number" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="开始时间:">
          <el-date-picker
            style="width:356px"
            v-model="start_date"
            type="datetime"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间:">
          <el-date-picker
            style="width:356px"
            v-model="end_date"
            type="datetime"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日 HH 时 mm 分 ss 秒"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      token: "",
      username: "",
      page: null,
      total: 0,
      tableData: [],
      product: "",
      dialogFormVisible1: false,
      group_price: "",
      group_number: "",
      start_date: "",
      end_date: "",
      id: ""
    };
  },
  created() {
    this.$store.state.topActiveId = 5;
    this.$store.state.leftTitle = "团购商品";
    this.geting();
  },

  methods: {
    shipments(id) {
      //确认发货弹窗

      const _this = this;
      this.axios
        .get(this.serve + "/admin/express_list", {
          params: {
            username: this.username,
            token: this.token
          }
        })
        .then(res => {
          _this.option = [];
          var json = res.data.data.results;
          _this.id = id;
          for (var key in json) {
            if (json[key].status == "1") {
              _this.option.push(json[key]);
            }
          }
        });
    },
    open4() {
      //错误时返回的息状态
      this.$message.error("添加失败");
    },
    open() {
      this.$message({
        //成功时 返回的状态
        message: "添加成功",
        type: "success"
      });
    },
    submit() {
      //弹窗提交

      this.axios
        .get(this.serve + "/admin/group_buy_edit", {
          params: {
            username: this.username,
            token: this.token,
            group_id: this.id,
            group_price: this.group_price,
            group_number: this.group_number,
            start_date: this.start_date / 1000,
            end_date: this.end_date / 1000
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.dialogFormVisible1 = false;
            this.$message({
              type: "success",
              message: "编辑成功"
            });
            this.geting();
          }else if(res.data.code == '403'){
            this.$message.error(res.data.msg); 
          } else if (res.data.status == "error") {
            this.$message.error("编辑失败");
          }
        });
    },
    red(id) {
      this.id = id;
      this.axios
        .get(this.serve + "/admin/group_buy_detail", {
          params: {
            username: this.username,
            token: this.token,
            group_id: id
          }
        })
        .then(res => {
          var json = res.data.data;
          this.group_price = json.g_price;
          this.group_number = json.g_number;
          this.start_date = json.start_date * 1000;
          this.end_date = json.end_date * 1000;
        });
    },
    del(id) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .get(this.serve + "/admin/delete_group_buy", {
              params: {
                username: this.username,
                token: this.token,
                group_id: id
              }
            })
            .then(res => {
              if (res.data.status == "success") {
                this.geting(this.page);
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }else if(res.data.code == '403'){
                this.$message.error(res.data.msg); 
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    setType(type) {
      //点击分类 订单
      this.resType = type;
      this.geting();
    },
    setPage(v) {
      //分页

      this.page = v;
      this.geting(v);
      this.selectAll = false;
    },
    geting(page) {
      //请求数据
      var that = this;
      this.username = this.$cookies.get("username");
      this.token = this.$cookies.get("token");
      this.axios
        .get(this.serve + "/admin/group_buy_list", {
          params: {
            token: this.token,
            username: this.username,
            page: page,
            product: this.product
          }
        })
        .then(res => {
          that.tableData = [];
          if (res.data.status == "success") {
            var json = res.data.data;
            that.total = json.total;
            that.page = json.page;
            for (var key in json.results) {
              var time = json.results[key].end_date;
              var timeNew = new Date(parseInt(time) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].end_date = timeNew;

              var time1 = json.results[key].start_date;
              var timeNew1 = new Date(parseInt(time1) * 1000)
                .toLocaleString()
                .replace(/:\d{1,2}$/, " ");
              json.results[key].start_date = timeNew1;
              json.results[key].yet =
                json.results[key].p_number - json.results[key].surplus;

              that.tableData.push(json.results[key]);
            }
          } else {
            if (res.data.msg == "无权访问") {
              this.role = false;
            }
          }
        });
    }
  }
};
</script>
<style lang="scss">
.Grouplist {
  background: #f5f5f5;
  color: #333;
  padding-bottom: 100px;
  min-height: 1000px;
  .topBar {
    margin-bottom: 40px;
  }
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .filtrate_seek_sousuo:hover {
    background-color: #0099ff;
    color: #fff;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
    position: relative;
    .rutun {
      width: 78px;
      height: 28px;
      background: #fff;
      border: 1px solid rgba(221, 221, 221, 1);
      text-align: center;
      margin-top: 9px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
    .rutun:hover {
      color: #0099ff;
    }
  }
  .filtrate_center {
    border-left: 1px solid rgba(221, 221, 221, 1);
    border-top: 1px solid rgba(221, 221, 221, 1);
    border-right: 1px solid rgba(221, 221, 221, 1);
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .table {
    background-color: #fff;
    padding: 10px 20px;
    .el-tree-node {
      font-size: 16px;
      padding: 5px 0;
    }
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>